module.exports = __webpack_public_path__ + "static/website-launch-min-c4aa88e0d4cbc8ac41ce5967a7cc5426.jpg";